import React, { Fragment } from 'react';
import styled from 'styled-components';

import { Text, Spacer, Flex } from '@badi/badi-components';

import { SEEKER_USER_ROLE } from 'datamodel/User/constants';
import BookingSummaryCard from 'components/booking-summary-card';
import GuestInformation from './components/guest-information';
import BookingInfoWithRoom from './components/booking-info-with-room';
import RoomPreview from 'components/room-preview';
import { BlockWrapper } from './styled-components';
import PaymentTodaySummary from 'components/payment-today-summary';

import { translate } from 'base/shared/Localization';

import StatusBadge from '../booking-status-badge';
import ExpirationBadge from '../booking-expiration-badge';
import BookingStepLayout from '../step-layout';
import RoomListerSummary from './room-lister-summary';
import { getStatusOnCheckoutFlow, getFormattedDate } from './utils';
import CancellationPolicyLink from './components/cancellation-policy-link';
import BadiPlusListingDetails from './components/badi-plus-listing-details';

const SummaryCardWrapper = styled.div`
  width: 100%;
`;

const PaymentCheckout = ({ title = '', bookingRequestDetail, onValidation }) => {
  const {
    expirationText,
    moveIn,
    moveOut,
    price = {},
    room,
    lister,
    status,
    lengthInMonths,
    exactMonthsLength,
    bookingValue,
    guestInformation,
  } = bookingRequestDetail;

  const { method, paymentBreakdown, ...priceWithoutMethod } = price;
  const mappedStatus = getStatusOnCheckoutFlow(status);
  const isBadiPlus = room?.isBadiPlusRoom;

  const getDescription = () => {
    isBadiPlus ? '' : translate('recovery.payment_checkout_subtitle');
  };

  const deposit = isBadiPlus ? paymentBreakdown?.installments?.total : room?.deposit;

  return (
    <BookingStepLayout
      description={getDescription()}
      sidebar={
        isBadiPlus ? (
          <BadiPlusListingDetails room={room} userRole={SEEKER_USER_ROLE} />
        ) : (
          [
            <Spacer key="room-summary" top={2}>
              <RoomListerSummary lister={lister} room={room} userRole="seeker" />
            </Spacer>,
            <Spacer key="cancellation-policy" top={4}>
              <CancellationPolicyLink />
            </Spacer>,
          ]
        )
      }
      sidebarTitle={
        isBadiPlus
          ? translate('recovery.badi_plus_payment_checkout_sidebar')
          : translate('recovery.payment_booking_request_details')
      }
      title={translate(title)}
    >
      <Spacer bottom={3} top={3}>
        <BookingInfoWithRoom {...room} checkInDate={moveIn} checkOutDate={moveOut} />
      </Spacer>

      {(deposit || price?.fee) && <PaymentTodaySummary deposit={deposit} fee={price?.fee} />}

      {guestInformation && (
        <Fragment>
          <Spacer top={3}>
            <Text body={1} bold data-qa="guest-information-title">
              {translate('recovery.badi_plus_payment_checkout_guest_information.title')}
            </Text>
            <Text body={3} data-qa="guest-information-description">
              {translate('recovery.badi_plus_payment_checkout_guest_information.description')}
            </Text>
          </Spacer>
          <Spacer top={3}>
            <GuestInformation
              guestInformation={guestInformation}
              onValidation={onValidation}
            ></GuestInformation>
          </Spacer>
        </Fragment>
      )}

      <Spacer bottom={3} top={3}>
        <Text body={1} bold data-qa="price-details-title">
          {translate('recovery.badi_plus_payment_checkout_price_details.title')}
        </Text>
        <Text body={3} data-qa="price-details-description">
          {translate('recovery.badi_plus_payment_checkout_price_details.description')}
        </Text>
      </Spacer>

      {paymentBreakdown && (
        <Spacer>
          <SummaryCardWrapper>
            <BookingSummaryCard paymentsBreakdown={paymentBreakdown} title={false} />
          </SummaryCardWrapper>
        </Spacer>
      )}
    </BookingStepLayout>
  );
};

export default PaymentCheckout;
